
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function AnalyticsPreview() {
  const benefits = [
    "Comprehensive performance analytics across all subjects",
    "Identify strengths and weaknesses with detailed insights",
    "Track your progress over time with visual charts",
    "Compare your performance with peer averages",
    "AI-driven analysis of your learning patterns",
    "Personalized recommendations based on your analytics"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/fe6ceec4-a337-46f1-a902-95609e691b1e.png",
      caption: "Analytics - Comprehensive performance insights"
    },
    {
      url: "/lovable-uploads/a7fab99d-d9bc-41e5-8828-43df93feb683.png",
      caption: "Adaptive Learning Path - Your personalized roadmap to success"
    },
    {
      url: "/lovable-uploads/871f51dc-3381-43a8-85dc-db55c930231a.png",
      caption: "Dashboard - Track your progress in one place"
    },
    {
      url: "/lovable-uploads/bb998b73-27d3-4993-8be1-46cd6b5a0501.png",
      caption: "Comparative Peer Analytics - See how you perform against others"
    }
  ];

  return (
    <FeatureShowcase
      title="Performance Analytics"
      description="Gain powerful insights into your learning progress with detailed analytics and visualizations."
      featureName="Analytics"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
